export function generateUniqueFileName(file: File) {
  const fileExtension = file.name.split('.').pop()
  const uniqueName = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`
  return `${uniqueName}.${fileExtension}`
};
